var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFbBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "30px",
    viewBox: "0 0 14 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "fb--black.75c4f71ac7fed27560b873339dab1931") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FINAL",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fb--black.75c4f71ac7fed27560b873339dab1931",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.30938872,30 L9.30938872,14.9982436 L13.4511299,14.9982436 L14,9.82855523 L9.30938872,9.82855523 L9.31642545,7.24107646 C9.31642545,5.89274219 9.44455386,5.17027381 11.381432,5.17027381 L13.97068,5.17027381 L13.97068,0 L9.82835248,0 C4.8527509,0 3.10146812,2.50785503 3.10146812,6.7252786 L3.10146812,9.82914073 L0,9.82914073 L0,14.998829 L3.10146812,14.998829 L3.10146812,30 L9.30938872,30 Z",
    id: "Shape-Copy-15"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbBlack);
export default __webpack_public_path__ + "static/media/fb--black.9124d9e366474e4ba6e95d7c6cc6c966.svg";
export { ForwardRef as ReactComponent };